// 🚨 Auto-generated file. Do not edit manually.

export const cityImages = {
  soddyDaisy: {
    url: 'https://res.cloudinary.com/mayes-auto-detailing-llc/image/upload/q_auto,f_auto/v1741265515/mad-web-app/city-images/soddy-daisy.jpg',
    publicId: 'mad-web-app/city-images/soddy-daisy',
    alt: 'Soddy Daisy City Image',
  },
  redBank: {
    url: 'https://res.cloudinary.com/mayes-auto-detailing-llc/image/upload/q_auto,f_auto/v1741265318/mad-web-app/city-images/red-bank.jpg',
    publicId: 'mad-web-app/city-images/red-bank',
    alt: 'Red Bank City Image',
  },
  ooltewah: {
    url: 'https://res.cloudinary.com/mayes-auto-detailing-llc/image/upload/q_auto,f_auto/v1741265250/mad-web-app/city-images/ooltewah.jpg',
    publicId: 'mad-web-app/city-images/ooltewah',
    alt: 'Ooltewah City Image',
  },
  bannerLogo: {
    url: 'https://res.cloudinary.com/mayes-auto-detailing-llc/image/upload/q_auto,f_auto/v1741236002/mad-web-app/city-images/banner-logo.png',
    publicId: 'mad-web-app/city-images/banner-logo',
    alt: 'Banner Logo City Image',
  },
  collegedale: {
    url: 'https://res.cloudinary.com/mayes-auto-detailing-llc/image/upload/q_auto,f_auto/v1741225113/mad-web-app/city-images/collegedale.jpg',
    publicId: 'mad-web-app/city-images/collegedale',
    alt: 'Collegedale City Image',
  },
  cleveland: {
    url: 'https://res.cloudinary.com/mayes-auto-detailing-llc/image/upload/q_auto,f_auto/v1741224457/mad-web-app/city-images/cleveland.jpg',
    publicId: 'mad-web-app/city-images/cleveland',
    alt: 'Cleveland City Image',
  },
  eastRidge: {
    url: 'https://res.cloudinary.com/mayes-auto-detailing-llc/image/upload/q_auto,f_auto/v1741223396/mad-web-app/city-images/east-ridge.jpg',
    publicId: 'mad-web-app/city-images/east-ridge',
    alt: 'East Ridge City Image',
  },
  '{business.address.city}': {
    url: 'https://res.cloudinary.com/mayes-auto-detailing-llc/image/upload/q_auto,f_auto/v1741182895/mad-web-app/city-images/{business.address.city}.jpg',
    publicId: 'mad-web-app/city-images/{business.address.city}',
    alt: '{business.address.city} City Image',
  },
};
